/// <amd-module name="Search/Package/Flux/ActionsHub" />

import * as BaseActionsHub from "Search/Shared/Base/ActionsHub2";
import { PackageSearchRequest, PackageSearchResponseContent, PackageResult } from 'Search/WebApi/Contracts/Search.Shared';

export class ActionsHub extends BaseActionsHub.ActionsHub<PackageSearchRequest, PackageSearchResponseContent, PackageResult> {
}